import React from 'react';

// Uppercase eyebrow label (Lato 12px / tracking 0.08em)
export function Eyebrow({ children, className = '' }) {
  return (
    <span className={`inline-block font-sans text-xs font-medium uppercase tracking-[0.08em] text-paelbi-brown ${className}`}>
      {children}
    </span>
  );
}

// Category pill badge sitting on cards
export function Badge({ children, className = '' }) {
  return (
    <span className={`inline-block rounded-[12px] bg-paelbi-badge px-3 py-1 font-sans text-[11px] font-semibold uppercase tracking-[0.06em] text-paelbi-brown ${className}`}>
      {children}
    </span>
  );
}

export default Badge;
